import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../../../../../../../redux/actions/errorHandlingAction";
import { IAsset } from "../../../../../../../../../features/file-attachments/types/file-attachment.interface";

export enum FlyerDetailPageAssetsActions {
  FetchPageAssets = "FlyerDetailPageAssets/FetchPageAssets",
  FetchPageAssetsFailure = "FlyerDetailPageAssets/FetchPageAssetsFailure",
  FetchPageAssetsSuccess = "FlyerDetailPageAssets/FetchPageAssetsSuccess",

  ResetPageAssets = "FlyerDetailPageAssets/ResetPageAssets",
  SetPageAssets = "FlyerDetailPageAssets/SetPageAssets",

  UploadPageAssets = "FlyerDetailPageAssets/UploadPageAssets",
  UploadPageAssetsFailure = "FlyerDetailPageAssets/UploadPageAssetsFailure",
  UploadPageAssetsSuccess = "FlyerDetailPageAssets/UploadPageAssetsSuccess",
}

export const fetchPageAssets = (pageId: number) =>
  action(FlyerDetailPageAssetsActions.FetchPageAssets, pageId);
export const fetchPageAssetsFailure = (error: IError) =>
  action(FlyerDetailPageAssetsActions.FetchPageAssetsFailure, error);
export const fetchPageAssetsSuccess = (assets: IAsset[]) =>
  action(FlyerDetailPageAssetsActions.FetchPageAssetsSuccess, assets);

export const resetPageAssets = () => action(FlyerDetailPageAssetsActions.ResetPageAssets);

export const setPageAssets = (assets: IAsset[]) =>
  action(FlyerDetailPageAssetsActions.SetPageAssets, assets);

export const uploadPageAssets = (assets: File[]) =>
  action(FlyerDetailPageAssetsActions.UploadPageAssets, assets);
export const uploadPageAssetsFailure = (error: IError) =>
  action(FlyerDetailPageAssetsActions.UploadPageAssetsFailure, error);
export const uploadPageAssetsSuccess = (assets: IAsset[]) =>
  action(FlyerDetailPageAssetsActions.UploadPageAssetsSuccess, assets);

const actionCreators = {
  fetchPageAssets,
  fetchPageAssetsFailure,
  fetchPageAssetsSuccess,

  resetPageAssets,
  setPageAssets,

  uploadPageAssets,
  uploadPageAssetsFailure,
  uploadPageAssetsSuccess,
};

export type FlyerDetailPageAssetsActionType = ActionType<typeof actionCreators>;
